export const shared = {
  password: 'Contraseña',
  changePassword: 'Cambia la contraseña',
  emailAddress: 'Dirección de correo electrónico',
};
